import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './Layout.scss';

const propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    'data-testid': PropTypes.string,
    gutters: PropTypes.oneOf([0, 1, 2, 3, 4, 5]),
    useNewBreakpoints: PropTypes.bool,
};

function Layout(props) {
    const {
        children,
        className = '',
        'data-testid': dataTestId,
        useNewBreakpoints = false,
        gutters = 0,
    } = props;

    return (
        <div className={classNames(
            {
                [styles.main]: !useNewBreakpoints,
                [styles.newMain]: useNewBreakpoints,
                [styles[`gutters-${gutters}`]]: gutters > 0,
            },
            className,
        )} data-testid={dataTestId}>
            {children}
        </div>
    );
}

Layout.propTypes = propTypes;

export default Layout;
